module.exports = __webpack_public_path__ + "img/s.67521a7e.jpg";